import React from 'react'
import { MegaMenuItem } from './types'
import { useTranslations } from 'next-intl'
import { NavItem } from '@/ui/layout/Header/NavBar/NavItem'
import { Label } from '@/ui/atoms/Label'
import { removeLangFromPath } from '@/utils/removeLangFromPath'

type MobileMegaMenuProps = {
  data: MegaMenuItem
  activeCategoryIndex: number | null
  setActiveCategoryIndex: (index: number | null) => void
  mobileView: 'categories' | 'links'
  setMobileView: (view: 'categories' | 'links') => void
  currentPath: string
}

export const MobileMegaMenu: React.FC<MobileMegaMenuProps> = ({
  data,
  activeCategoryIndex,
  setActiveCategoryIndex,
  mobileView,
  setMobileView,
  currentPath,
}) => {
  const handleCategoryClick = (index: number) => {
    setActiveCategoryIndex(index)
    setMobileView('links')
  }

  const isCurrentProcess = (href: string) => {
    const pathParts = removeLangFromPath(currentPath).split('/')
    const linkParts = removeLangFromPath(href).split('/')

    return pathParts.at(1) === linkParts.at(1) && pathParts.at(2) === linkParts.at(2)
  }

  const t = useTranslations('megaMenu')
  const publicT = useTranslations('public')

  const activeCategory =
    typeof activeCategoryIndex === 'number' ? data.categories[activeCategoryIndex] : null

  return (
    <div className="flex flex-col flex-grow overflow-y-auto">
      {mobileView === 'categories' && (
        <div className="flex flex-col w-full animate-in slide-in-from-left duration-300 ease-out">
          {data.categories.map((category, index) => (
            <NavItem
              key={index}
              onClick={() => handleCategoryClick(index)}
              label={category.title}
              showNextIcon={true}
              isMobile={true}
            />
          ))}
        </div>
      )}

      {mobileView === 'links' && activeCategory && (
        <div className="flex flex-col flex-grow animate-in slide-in-from-right duration-300 ease-out">
          <h4 className={'px-2 text-label-S-regular text-text-faded-inverted mb-5'}>
            {t('processesOf')} {activeCategory.title}
          </h4>
          {activeCategory.links.map((link, linkIndex) => {
            return link.isComingSoon ? (
              <div className={'text-body-M-regular py-2 px-2'} key={linkIndex}>
                <span className={'text-text-faded-inverted me-2'}>{link.label}</span>
                <Label
                  title={publicT('coming-soon')}
                  size={'small'}
                  variant={'transparentInverted'}
                />
              </div>
            ) : (
              <NavItem
                key={linkIndex}
                href={link.href}
                label={link.label}
                isMobile={true}
                isActive={isCurrentProcess(link.href)}
                className={'!text-body-M-regular'}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}
